import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type AuthFlow = "signup" | "login";

interface PendingVerification {
  flow: AuthFlow;
  email?: string;
  phoneNumber?: string;
  redirectUrl?: string;
}

export interface AuthState {
  pendingVerification: PendingVerification | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  pendingVerification: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setPendingVerification(state, action: PayloadAction<PendingVerification>) {
      state.pendingVerification = action.payload;
    },
    clearPendingVerification(state) {
      state.pendingVerification = null;
    },
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
  },
});

export const {
  setPendingVerification,
  clearPendingVerification,
  setAuthenticated,
} = authSlice.actions;

export default authSlice.reducer;
